import React from "react";
import { PRIVACY_POLICY_URL } from "../config/legal";

export const MadeBy = ({ className }: { className?: string }) => {
  return (
    <div className={className}>
      <p style={{ margin: 0 }}>
        <a href="https://copresent.app" target="_blank" rel="noreferrer">
          Copresent
        </a>
        <span style={{ margin: '0 6px', opacity: 0.5 }}>·</span>
        <a href={PRIVACY_POLICY_URL} target="_blank" rel="noreferrer" style={{ color: '#6b7280' }}>
          Privacy Policy
        </a>
      </p>
    </div>
  );
};
